/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { HeadingDesc, HeadingDescSmall } from '../../../../Components/Headings';
import { ProfileCard, SimpleCard } from '../../../../Components/Card';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../../../Components/button';
import { SimpleSliderSmall } from '../../../../Components/sliders';
import { RatingStars } from '../../../../Components/rating';
import { SimpleTag } from '../../../../Components/tags';
import {
  CancelModal,
  GiveReviewsModal,
  ReadReviewsModal,
  ViewPrecriptionModal
} from '../../../../Components/customModals';
import img from '../../../../assets/images/svg/doc.svg';
import rightArrow from '../../../../assets/images/svg/right-arrow-white.svg';
import infoIcon from '../../../../assets/images/svg/infoIcon.svg';
import './pastAppointments.css';

const cardsData = [
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Prof. Dr. Saira Mustehsan',
    proff: 'Internal Medicine Specialist, Family Physician',
    edu: 'M.B.B.S, F.C.P.S. (Medicine), Ph.D',
    exp: ''
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  }
];

const appointDocs = [
  {
    docImage: img,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    place: 'The Doctor’s Plaza (Clifton)',
    time: 'Tomorrow, Apr 7 - 9:45 am',
    availabe: 'Video Consultation',
    price: '500',
    status: false
  },
  {
    docImage: img,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availabe: 'In-Person Appointment',
    place: '',
    time: 'Tomorrow, Apr 7 - 9:45 am',
    price: '300',
    status: true
  },
  {
    docImage: img,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availabe: 'Video Consultation',
    place: 'The Doctor’s Plaza (Clifton)',
    time: 'Tomorrow, Apr 7 - 9:45 am',
    price: '500',
    status: false
  },
  {
    docImage: img,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availabe: 'In-Person Appointment',
    place: 'The Doctor’s Plaza (Clifton)',
    time: 'Tomorrow, Apr 7 - 9:45 am',
    price: '400',
    status: true
  }
];

function PastAppointments() {
  const [modal, setModal] = useState('false');
  const items = cardsData.map((card, index) => (
    <ProfileCard card={card} key={index + 1} />
  ));
  return (
    <div className="pastAppointments">
      {appointDocs.map((appointDoc, index) => {
        const {
          docImage,
          docName,
          speciality,
          availabe,
          place,
          time,
          price,
          status
        } = appointDoc;
        return (
          <SimpleCard key={index}>
            <Row className="docInfoCard">
              <Col md={1}>
                <div className="imgBox">
                  <img src={docImage} alt="docImage" />
                </div>
              </Col>
              <Col md={5}>
                <div className="info">
                  <div className="docName">
                    <HeadingDesc text={docName} />
                  </div>
                  <div className="speciality">
                    <HeadingDescSmall text={speciality} />
                  </div>
                  {status === true ? (
                    <div className="availabe one">
                      <HeadingDescSmall text={availabe} />
                    </div>
                  ) : (
                    <div className="availabe two">
                      <HeadingDescSmall text={availabe} />
                    </div>
                  )}
                  <div className="time">
                    <HeadingDescSmall text={time} />
                    {place !== '' ? 'at ' : ''}
                    <AncerWithUnderlineSmall text={place} />
                  </div>
                  {/* <div
                    className={`btn_container ${status ? 'disabled-link' : ''}`}
                  > */}
                  {status === false ? (
                    <div className="ratingContainer">
                      <div>
                        <RatingStars edit={false} />
                        <button
                          onClick={() => setModal('m2')}
                          type="button"
                          className="underline_ancer_small"
                        >
                          READ YOUR REVIEW
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="ratingContainer">
                      <div>
                        <RatingStars edit={false} />
                        <button
                          onClick={() => setModal('m3')}
                          type="button"
                          className="underline_ancer_small t-red"
                        >
                          PENDING REVIEW
                        </button>
                      </div>
                      <SimpleTag text="Review this doctor and get 10% off your next appointment">
                        <img src={infoIcon} alt="infoIcon" />
                      </SimpleTag>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={1}>
                <SimpleTag text={price} />
              </Col>
              <Col md={4} className="offset-lg-1">
                <div className="btnBox">
                  <div className="btn_container">
                    <button className="simple_btn_small primary" type="button">
                      FOLLOW UP APPOINTMENT
                    </button>
                  </div>
                  <button
                    onClick={() => setModal('m4')}
                    className="simple_btn_small danger"
                    type="button"
                  >
                    VIEW PRESCRIPTION(S
                  </button>
                </div>
              </Col>
            </Row>
          </SimpleCard>
        );
      })}
      <SimpleSliderSmall
        className="profileSliderSmall"
        sliderTitle="Top Rated General Physicians"
      >
        {items}
      </SimpleSliderSmall>
      <Row className="btnRow">
        <Col md={10}>
          <SimpleAncerSmall text="browse all our doctors">
            <img src={rightArrow} alt="rightArrow" />
          </SimpleAncerSmall>
        </Col>
      </Row>
      <CancelModal show={modal === 'm1'} close={() => setModal(false)} />
      <ReadReviewsModal show={modal === 'm2'} close={() => setModal(false)} />
      <GiveReviewsModal show={modal === 'm3'} close={() => setModal(false)} />
      <ViewPrecriptionModal
        show={modal === 'm4'}
        close={() => setModal(false)}
      />
    </div>
  );
}

export default PastAppointments;
